var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-text-input-dropdown"},[_c('v-select',_vm._g(_vm._b({staticClass:"text-input"},'v-select',_vm.attrs,false),_vm.$listeners),[_c('template',{slot:"no-options"},[_vm._v(" Элементов для выбора нет ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }